import { ReactElement } from 'react'

import { SaldoItem, SaldoItemGroup } from '@/components'
import { UserWithHourBalances } from '@/entities/HourBalances/HourBalances'
import { trans } from '@/helpers/trans'


export function EmployeeSaldoGroup({
    absenceHours,
    specialLoaHours,
    tvtLoaHours,
    mutatedTvtHours,
    leaveOfAbsenceHours,
    vacancyLoaHours,
    workedHours,
    isEligibleForTimeForTime,
}: UserWithHourBalances): ReactElement {
    return (
        <div className="loket-hours-per-period__saldo-items">
            <SaldoItemGroup>
                <SaldoItem
                    isTitle
                    title={trans('pages.absences.loketBalancesPerPeriod.usedLeaveAbsenceHours')}
                    hours={leaveOfAbsenceHours}
                />
                <SaldoItem
                    title={trans('pages.absences.loketBalancesPerPeriod.vacancyLeaveOfAbsenceHours')}
                    hours={vacancyLoaHours}
                />
                <SaldoItem
                    title={trans('pages.absences.loketBalancesPerPeriod.specialLeaveOfAbsenceHours')}
                    hours={specialLoaHours}
                />
                <SaldoItem
                    title={trans('pages.absences.loketBalancesPerPeriod.tvtLeaveOfAbsenceHours')}
                    hours={tvtLoaHours}
                />
            </SaldoItemGroup>
            {isEligibleForTimeForTime && (
                <SaldoItem
                    isTitle
                    title={trans('pages.absences.loketBalancesPerPeriod.tvtMutationHours')}
                    hours={mutatedTvtHours}
                />
            )}
            <SaldoItem
                isTitle
                title={trans('pages.absences.loketBalancesPerPeriod.absenceHours')}
                hours={absenceHours}
            />
            <SaldoItem
                isTitle
                title={trans('pages.absences.loketBalancesPerPeriod.workedHours')}
                hours={workedHours}
            />
        </div>
    )
}
